/**
 * Input intents — US 12.01. Gameplay consumes ONLY these; no gameplay code
 * ever references a key code, touch event, or gamepad button. Keyboard,
 * touch and gamepad are separate sources that each translate to this
 * vocabulary, so adding an input device touches exactly one module.
 */

/** Discrete intents fire once per activation. */
export type DiscreteIntent =
  | 'INTERACT'
  | 'CANCEL'
  | 'OPEN_INVENTORY'
  | 'OPEN_JOURNAL'
  | 'OPEN_APARTMENT'
  | 'OPEN_ALBUM'
  | 'CONFIRM';

/**
 * The movement intent is continuous: a direction vector with components in
 * [-1, 1], already normalised by the source when diagonal (US 01.01 — no
 * diagonal speed advantage). {0,0} means "no movement input".
 */
export interface MoveVector {
  x: number;
  y: number;
}

export interface IntentFrame {
  move: MoveVector;
  /** Discrete intents activated since the previous drain, in order. */
  pressed: DiscreteIntent[];
}

/** Normalises a raw direction so diagonals carry no speed advantage. */
export function normaliseMove(x: number, y: number): MoveVector {
  const len = Math.hypot(x, y);
  if (len === 0) return { x: 0, y: 0 };
  // Cardinal input stays exact; anything longer than unit length scales down.
  if (len <= 1) return { x, y };
  return { x: x / len, y: y / len };
}
